import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

import { UtilsModule } from '@shared/utils/utils.module';

import { AppCommonModule } from '@app/shared/common/app-common.module';

import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { SmsVerificationModalComponent } from '@app/shared/layout/profile/sms-verification-modal.component';

import { HeaderComponent } from '@app/shared/layout/header/header.component';
import { SidebarComponent } from '@app/shared/layout/sidebar/sidebar.component';
import { NavbarComponent } from '@app/shared/layout/navbar/navbar.component';
import { HeaderUserComponent } from '@app/shared/layout/header/components/user.component';

import { LanguageSwitchComponent } from '@app/shared/layout/header/components/language-switch.component';

import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { HeaderNotificationsComponent } from './shared/layout/notifications/header-notifications.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';

import { SettingDrawerComponent } from '@app/shared/layout/setting-drawer/setting-drawer.component';
import { SettingDrawerItemComponent } from '@app/shared/layout/setting-drawer/setting-drawer-item.component';

import { FileUploadModule } from 'ng2-file-upload';
import { ImageCropperModule } from 'ngx-image-cropper';

import { SessionTimeoutModalComponent } from './shared/common/session-timeout/session-timeout-modal-component';
import { SessionTimeoutComponent } from './shared/common/session-timeout/session-timeout.component';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from '@shared/layout/layout.module';
import { ImpersonationService } from './pages/admin/users/impersonation.service';
import { LayoutDefaultModule } from '@node_modules/@delon/theme/layout-default';
import { ReuseTabModule } from '@delon/abc/reuse-tab';
import { NZ_DATE_LOCALE, NZ_I18N, vi_VN as zorroLang } from 'ng-zorro-antd/i18n';
import { DELON_LOCALE, en_US as delonLang } from '@delon/theme';
import { vi as dateLang } from 'date-fns/locale';
import { default as ngLang } from '@angular/common/locales/vi';
import { WelcomeComponent } from './shared/layout/welcome/welcome.component';

const LANG = {
    abbr: 'vi',
    ng: ngLang,
    zorro: zorroLang,
    date: dateLang,
    delon: delonLang,
};
const LANG_PROVIDES = [
    { provide: LOCALE_ID, useValue: LANG.abbr },
    { provide: NZ_I18N, useValue: LANG.zorro },
    { provide: NZ_DATE_LOCALE, useValue: LANG.date },
    { provide: DELON_LOCALE, useValue: LANG.delon },
];
const NAVCOMPONENTS = [
    HeaderComponent,
    SidebarComponent,
    NavbarComponent,
    HeaderUserComponent,
    LanguageSwitchComponent,
    HeaderNotificationsComponent,
];


@NgModule({
    imports: [BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        FileUploadModule,
        ImageCropperModule,
        LayoutModule,
        LayoutDefaultModule,
    ],
    declarations: [
        AppComponent,
        ...NAVCOMPONENTS,
        LoginAttemptsModalComponent,
        ChangePasswordModalComponent,
        MySettingsModalComponent,
        ChangeProfilePictureModalComponent,
        SmsVerificationModalComponent,
        NotificationsComponent,
        NotificationSettingsModalComponent,
        SettingDrawerComponent,
        SettingDrawerItemComponent,
        SessionTimeoutModalComponent,
        SessionTimeoutComponent,
        WelcomeComponent,
    ],
    entryComponents: [
        LoginAttemptsModalComponent,
        ChangePasswordModalComponent,
        MySettingsModalComponent,
        ChangeProfilePictureModalComponent,
        SmsVerificationModalComponent,
        NotificationSettingsModalComponent,
        SettingDrawerComponent,
        SettingDrawerItemComponent,
    ],
    providers: [UserNotificationHelper, ImpersonationService,
        ...LANG_PROVIDES],
})
export class AppModule {
}
